<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">BALLISTIC</p>
<p class="chap_line"></p>
<p class="center"><span class="big">T</span>he straight and narrow path to heaven’s highest gate is never fatalistic</p>
<p class="center">Because your works and faith must be to the highest standards before the gate to the Celestial Kingdom opens to let you in; but when your poor works and faith are like a millstone around your soul, you will be refused entrance but to the level earned, not what you foolishly hoped for, you are just going to go with gnashing teeth utterly ballistic.</p>
<p class="center1">Faith, repentance, works, and prayer are the four corners of your house built upon the rock of Christ’s plan of salvation</p>
<p class="center">And the works that count most are the ones<br/> that are anonymous and never need ovation.</p>
<p class="center1">Precept upon precept, line upon line up the narrow staircase of knowledge and understanding do you earn step by step the right to climb</p>
<p class="center">For passing through the eye of the needle is as a wide-open gate in comparison for you to be able to pass through the gate of the Celestial Kingdom, heaven’s most exalted clime.</p>
<p class="center1">Every aspect of the natural man must be aggressively purged before you earn a soul divine</p>
<p class="center">And that can happen here but takes so much longer when you pass through the veil’s indelible line.</p>
<p class="center1">Hour by hour, day by day, you choose whether to wisely use or foolishly waste your precious time</p>
<p class="center">For there is nothing but a perfect accounting and judgment of your every thought, action, or deed no matter how sublime.</p>
<p class="center1">The straight and narrow path to heaven’s highest gate is never fatalistic</p>
<p class="center">Because your works and faith must be to the highest standards before the gate to the Celestial Kingdom opens to let you in; but when your poor works and faith are like a millstone around your soul, you will be refused entrance but to the level earned, not what you foolishly hoped for, you are just going to go with gnashing teeth utterly ballistic</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap013.vue?31303c3e